var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIm0(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_280_3216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.80352 23.1593L6.41602 15.003L0.275391 9.39678L8.53008 8.4124L11.9613 0.837402L15.4488 8.38428L23.7129 9.30772L17.6145 14.9608L19.2879 23.103L12.0316 19.0483L4.80352 23.1593Z",
    fill: "#FFD759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9941 12.0015L0.275391 9.3999L6.41602 15.0062L11.9941 12.0015Z",
    fill: "#FABD3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0031 12L4.8125 23.1609L12.0406 19.05L19.2969 23.1047L12.0031 12Z",
    fill: "#FABD3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.0031L23.7188 9.3125L17.6203 14.9656L12 12.0031Z",
    fill: "#FABD3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9629 0.837402L11.9957 11.9983L15.4504 8.38428L11.9629 0.837402Z",
    fill: "#FABD3B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_280_3216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIm0);
export default __webpack_public_path__ + "static/media/im0.44a8afc244fc180c12191bbb0bba4e19.svg";
export { ForwardRef as ReactComponent };